import { BarceloComponent } from "components-utils";

const TargetComponents = {
  cardHotelHomeTarget: BarceloComponent({ selector: ".mod--card-hotel-home-target", path: "barcelo/adobeTarget/card-hotel-home-target/js/card-hotel-home-target", enableObserver: true, ignoreViewport: true }),
  cardHotelTarget: BarceloComponent({ selector: ".mod--card-hotel-target", path: "barcelo/adobeTarget/card-hotel-target/js/card-hotel-target", enableObserver: true, ignoreViewport: true }),
};

export default TargetComponents;
